<template>
  <div class="ui-dadata-autocomplete" v-click-outside="handleClickOutside">
    <input
      class="ui-dadata-autocomplete__input t-input"
      :class="{ _error: error, _valid: valid }"
      type="text"
      :placeholder="placeholder"
      v-model="inputValue"
      @input="debouncedInput"
      @focus="handleFocus"
      :disabled="disabled"
    >
    <transition name="fade">
      <div
        v-if="isOpened"
        class="ui-dadata-autocomplete__dropdown"
      >
        <div
          v-if="isPending"
          class="ui-dadata-autocomplete__text ui-dadata-autocomplete__text--secondary ui-dadata-autocomplete__title  ui-dadata-autocomplete__loader"
        >Поиск...</div>

        <template v-else>
          <template v-if="inputValue.length">
              <ul
                v-if="options.length"
                class="ui-dadata-autocomplete__list"
              >
                <template
                  v-for="option in options"
                >
                  <li
                    class="ui-dadata-autocomplete__list-item"
                    @click="handleItemClick(option)"
                  >
                    <span
                      class="ui-dadata-autocomplete__text"
                    >
                      {{ option.opf || '' }}
                      "{{ option.name }}"
                    </span>
                    <span>
                      {{ option.inn && `ИНН ${option.inn};` }}
                      {{ option.kpp && `КПП ${option.kpp}` }}
                    </span>
                    <span>
                      {{ option.country || location.country }},
                      {{ option.region_with_type || location.region_with_type }}
                    </span>
                    {{ option.address }}

                    {{ option.index && `${option.index}`}}
                  </li>
                </template>
              </ul>

              <div
                v-else
                class="ui-dadata-autocomplete__text ui-dadata-autocomplete__title ui-dadata-autocomplete__text--secondary"
              >Ничего не найдено</div>
          </template>
  
          <div
            class="ui-dadata-autocomplete__text ui-dadata-autocomplete__title ui-dadata-autocomplete__text--secondary"
            v-else
          >Пример: ООО "Сбербанк"</div>
        </template>

      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { debounce } from 'lodash';

export default {
  name: 'ui-dadata-organisation-autocomplete',
  props: {
    value: {
      type: Object,
      default: null,
    },
    placeholder: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    locations: {
      type: Array,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    location: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isOpened: false,
      inputValue: '',
      prevOption: null,
      options: [],
      isPending: false,
      isFirstTouch: true
    }
  },
  computed: {
    debouncedInput () {
      return debounce(this.handleInputChange, 500);
    },
  },
  methods: {
    ...mapActions({
      getOrganisationDadata: 'getOrganisationDadata',
    }),
    handleFocus (e) {
      this.isOpened = true;
      this.$emit('focus', e)
    },
    async handleInputChange (e) {
      try {
        const res = await this.getOrganisationDadata({
          query: this.inputValue,
          token: this.$root.siteDadataKey || undefined,
          country: this.location.country
        });
        this.options = res;
      } finally {
        this.isPending = false
      }
    },
    resetField () {
      this.inputValue = ''
      this.$emit('update:value', null);
    },
    setCurrentOption (option) {
      if (!option) return this.resetField();

      const newOption = {
        ...option,
        city: option.city || this.location.city,
        country: option.country || this.location.country,
        index: option.index || this.location.index,
        region_with_type: option.region_with_type || this.location.region,
        region: option.region || this.location.region
      }
      
      this.$emit('update:value', newOption);

      const {opf, name, inn, kpp, address, country} = newOption;
      this.inputValue = `${opf } "${name}", ${inn} ${kpp && `, ${kpp}`}`.trim();

      this.options = [ option ];
    },
    handleClickOutside () {
      if (!this.isOpened) return;

      this.setCurrentOption(this.value);

      this.isOpened = false;
    },
    handleItemClick (option) {
      this.setCurrentOption(option);
      this.isOpened = false;
    },
  },
  watch: {
    inputValue (v) {
      this.isPending = true;
    },
    isOpened (v) {
      if (v) return;
      this.isPending = false;
    },
    "location.country" (v) {
      this.resetField();
    }
  }
}
</script>

<style lang="sass">
@import './styles'
</style>


// WEBPACK FOOTER //
// src/templates/components/ui-components/dadata-autocomplete/dadata-organisation-autocomplete.vue